<!--suppress ALL -->
<template>
  <div>
    <div class="page case-detail__content">
      <div class="padding15 bg-content m-b-24">
        <div class="m-b-24">
          <el-button size="small" icon="el-icon-upload" @click="importFIle" v-if="this.$hasPerm('F001')">文件上传</el-button>
        </div>
        <div class="bg-content padding15">
          <el-form size="small" label-width="50px" ref="searchRef">
            <el-row :gutter="24">
              <!--  此处查询条件            -->
<!--              <el-col :span="5">-->
<!--                <el-form-item label="上传账号" label-width="85px">-->
<!--                  <el-input v-model="searchReq.uploader" placeholder="请输入查询条件" style="width: 100%;"/>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
              <el-col :span="7">
                <el-form-item label="文件名" label-width="85px">
                  <el-input v-model="searchReq.fileName" placeholder="请输入查询条件" style="width: 100%;"/>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="处理状态" label-width="140px">
                  <el-select v-model="searchReq.statue" filterable clearable placeholder="请选择" style="width: 100%;">
                    <el-option label="已处理" :value="1"/>
                    <el-option label="未处理" :value="0"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4" :offset="0">
                <div class="text right">
                  <el-button type="primary" size="small" plain @click="searchReq.page = 1; getList();"><i class="fa fa-search"></i> 搜索</el-button>
                  <el-button size="small" @click="searchReq.fileName = null; searchReq.statue = null">重置</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="padding15 bg-content">
          <el-table size="small" :data="robotFileProcess.list">
            <el-table-column fixed property="fileName"  label="文件名" align="center"/>
            <el-table-column fixed property="originalCosAddress"  label="存储地址" align="center"/>
            <el-table-column fixed property="uploader"  label="上传者" align="center"/>
            <el-table-column fixed property="createTime"  label="上传时间" align="center"/>
            <el-table-column fixed property="statue"  label="状态" align="center">
              <template slot-scope="scope">
                {{ scope.row.statue === 0 ? '未处理' : '已处理'+ scope.row.processCount+ '次'}}
              </template>
            </el-table-column>
            <el-table-column fixed label="操作"  v-if="this.$hasPerm('F001')" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="updateVisiable(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
                <el-button type="text" size="small" @click="download(scope.row.id)"><i class="el-icon-download"></i>&nbsp;下载</el-button>
                <el-button type="text" size="small" @click="remove(scope.row.id)"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="text center margin15-tb">
            <el-pagination
              background
              layout="prev, pager, next, sizes, total"
              :total="robotFileProcess.totalRecords"
              :page-size="searchReq.limit"
              :current-page="searchReq.page"
              @current-change="currentChange"
              @size-change="sizeChange">
            </el-pagination>
          </div>
        </div>
        <!-- 文件上传 -->
        <el-dialog title="文件上传" :visible.sync="importVisible" width="30%" center>
          <div>
            <el-form size="small" label-width="140px">
              <el-form-item label="选取文件">
                <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :before-remove="beforeRemove"
                  multiple
                  :limit="1"
                  :auto-upload="false"
                  :on-exceed="handleExceed"
                  :file-list="fileList"
                  :on-change="fileChanged">
                  <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">目前只能上传 .xlsx 文件</div>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
<!--            <el-button icon="el-icon-download" size="small"><a href="static/template/caseImportTemplate.xlsx" download style="color: inherit; text-decoration: none;">模板下载</a></el-button>-->
            <el-button type="primary" size="small" @click="uploadFile">上 传</el-button>
          </div>
        </el-dialog>
        <el-dialog title="编辑文件" :visible.sync="updateVisible" width="30%" center>
          <div>
            <el-form size="small" label-width="140px">
              <el-form-item label="操作类型">
                <el-select  filterable clearable placeholder="请选择" v-model="processDataReq.operationType" @change="processDataTypeChange" style="width: 80%;">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="操作方式">
                <el-select 使用 filterable clearable placeholder="请选择" v-model="processDataReq.operationMethod" style="width: 80%;">
                  <el-option
                    v-for="method in operationMethods"
                    :key="method.value"
                    :label="method.label"
                    :value="method.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="处理字段">
                <el-input placeholder="请输入内容多个字段用分号“;”隔开" type="textarea" v-model="processDataReq.fields" style="width: 80%;" :rows="2" :maxlength="32" show-word-limit resize="none"/>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="updateVisible = false" size="small">取 消</el-button>
            <el-button type="primary" size="small" @click="processFile">处 理</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      options: [
        {
          value: 'Excel文件加密',
          label: '1.Excel文件加密'
        },
        {
          value: 'Excel文件解密',
          label: '2.Excel文件解密'
        }
      ],
      searchReq: {
        processCount: null,
        statue: null,
        uploader: null,
        fileName: null,
        page: 1,
        limit: 10,
        order: 'rfp.create_time',
        sort: 'desc'
      },
      robotFileProcess: { 'totalRecords': 0, list: [] },
      processDataReq: {
        id: null,
        operationType: null,
        operationMethod: null,
        fields: null
      },
      updateVisible: false,
      importVisible: false,
      fileList: [],
      upload: {
        companyIds: [],
        startTime: null,
        endTime: null
      },
      dialogVisible: false,
      encryptionMethods: [
        { label: 'MD5加密', value: 'MD5加密' },
        { label: 'AES加密', value: 'AES加密' },
        { label: 'DES加密', value: 'DES加密' }
      ],
      decryptionMethods: [
        { label: 'MD5解密', value: 'MD5解密' },
        { label: 'AES解密', value: 'AES解密' },
        { label: 'DES解密', value: 'DES解密' }
      ]
    };
  },
  computed: {
    operationMethods() {
      if (this.processDataReq.operationType === 'Excel文件加密') {
        return this.encryptionMethods;
      } else if (this.processDataReq.operationType === 'Excel文件解密') {
        return this.decryptionMethods;
      }
      return [];
    }
  },
  methods: {
    importFIle() {
      this.fileList = [];
      this.importVisible = true;
    },
    updateVisiable(row) {
      this.processDataReq.id = row.id;
      this.processDataReq.operationType = row.operationType;
      this.processDataReq.operationMethod = row.operationMethod;
      this.processDataReq.fields = row.fields;
      this.updateVisible = true;
    },
    processFile() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/fileProcess/process/',
        data: this.processDataReq
      }).then(() => {
        loading.close();
        this.getList();
        this.updateVisible = false;
      }).catch(() => {
        loading.close();
      });
    },
    download(Id) {
      this.$confirm('您确定要下载该文件吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'POST',
          url: `/fileProcess/download/${Id}`
        }).then((res) => {
          this.downloadData(res.data);
        }).then(() => {
          // 刷新
          this.getList();
        });
      });
    },
    async downloadData(filePath) {
      if (!filePath) {
        this.$message({
          type: 'error',
          message: '下载失败，请刷新重试'
        });
        return;
      }
      await this.$downloadSplit({
        url: '/caseList/download',
        path: filePath
      }).then(() => {
        this.$ajax({
          url: 'caseList/delete',
          method: 'DELETE',
          params: { 'filePath': filePath }
        });
      });
    },
    remove(id) {
      // console.log(id)
      this.$confirm('您确定要删除该文件吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'DELETE',
          url: `/fileProcess/remove/${id}`
        }).then(() => {
          // 刷新 //
          this.getList();
        });
      });
    },
    getList() {
      this.$ajax({
        method: 'POST',
        url: '/fileProcess/list',
        data: this.searchReq
      }).then((res) => {
        this.robotFileProcess.list = res.data.list;
        this.robotFileProcess.totalRecords = res.data.totalRecords;
      });
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.getList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.getList();
    },
    handleRemove(file, fileList) {
      console.warn(file, fileList);
    },
    beforeRemove() {
      this.fileList = [];
    },
    handleExceed(files, fileList) {
      console.warn(fileList);
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length} 个文件`);
    },
    fileChanged(files, fileList) {
      if (files.size > (5 * 1024 * 1024)) {
        this.$message.warning('文件大小超出5M,请重新选择！');
        this.fileList = [];
        return;
      }
      this.fileList = fileList;
    },
    handlePreview(file) {
      console.warn(file);
    },

    uploadFile() {
      if (this.fileList.length === 0) {
        this.$message({
          type: 'error',
          message: '上传文件不能为空!'
        });
        return;
      }
      const formData = new FormData();
      formData.append('file', this.fileList[0].raw);
      this.$ajax({
        url: '/fileProcess/uploadFile',
        contentType: 'multipart/form-data',
        data: formData
      }).then((res) => {
        if (res.data !== null) {
          this.$notify({
            title: '提示',
            message: res.data,
            duration: 0
          });
        }
        this.importVisible = false;
        this.getList();
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    }
  },
  mounted() {
    this.getList();
    this.companyList();
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/fileProcess/list.vue